<template>
  <div class="container-dashboard-v3"   v-bind:class="{'run-loading':loadingData}">
      <div class="container-dashboard-content" v-if="loadingData==false">
        <div class="content" v-if="master.contract_id">
          <b-container fluid>
            <b-row>
              <b-col>
                <div class="dashboard-toolbar">
                  <svg @click="openFilterPopup" xmlns="http://www.w3.org/2000/svg" width="20" height="20"  fill="currentColor" class="bi bi-filter filter-link" viewBox="0 0 16 16">
                    <title>Filter</title>
                    <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>
                  </svg>
                </div>
                <div>
                  &nbsp;
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div class="v3-card-container-6MHI">
                  <div class="chart-header">6-Monthly Hazard Inspection for {{ display_contract_name }} ({{ display_date }})</div>
                  <div class="chart-body">
                    <div id="jobStatusBarChart1" class="chart-main">
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div class="no-contract" v-if="!master.contract_id">
          <div class="child">Please choose a contract to load the dashboard.</div>
        </div>
      </div>
        <b-modal id="modal-Filter" title="Filters" hide-footer :centered="true" v-model="modals.filter.open">
            <b-form>
                <b-row>
                  <b-col md="12">
                    <gofix-form-dropdown
                        vLabel="reference_value_text"
                        label="Period"
                        :options="modals.filter.data.dates"
                        v-model="modals.filter.data.dateModel"
                        class="gofixInputNoMinWidth"
                        :required="true">
                    </gofix-form-dropdown>
                  </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" :loading="modals.filter.loading" @click="applyFilter" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {LOAD_CHILDREN_OPTIONS} from '@riophae/vue-treeselect';
import moment from 'moment';
import * as d3 from 'd3';
const _ = require('lodash');
const simulateAsyncOperation = fn => {
    setTimeout(fn, 500);
};

  export default {
    data: function() {
      return {
        loadingData: true,
        pm1_chart_colors: {
          VERIFIED: '#73ac45',
          "EXPIRED/MISSED": '#a5a5a3',
          PLANNED: '#fcc100',
          BLOCK: '#3e74cc'

        },
        master: {
          contract_id: 0,
          contract_name: "",
          root_property_id: 0,
          root_service_category_id: 0,
          tableItems: [],
          data: {
            job: {},
            issue_register: [],
            jobCompletion: [],
            jobCompletionPercent: 0,
            maintenance_programs: [],
          },
          filter: {
            property: null,
            dates:[],
            dateModel:null,
          },
        },
        init: true,
        modals: {
          filter: {
            open: false,
            loading: false,
            data: {
              property: null,
              dates:[],
              dateModel:null,
            }
          },
        },
        dataService: [],
        charts: {
          chart1:null,
          chart2:null,
          chart3:null,
          chart4:null,
          chart5:null,
          chart6:null,
        },
      }
    },

    async created() {
        if(this.ClientContractID && this.ClientContractID.contract_terms){
            this.loadingData = true;
            this.master.contract_id = this.ClientContractID.id;
            this.master.contract_term_id = this.ClientContractID.contract_terms[0].id;
            this.master.contract_name = this.ClientContractID.contract_name;
            this.loadRootProperty();
        }
        else{
          this.loadingData = false;
          this.master.contract_id = null;
          this.master.contract_term_id = null;
        }
    },

    async mounted() {   
    },

    computed: { 
      ...mapGetters({
        ClientContractID: 'ContractController/ClientContractID',
      }),
      display_date() {
        if(this.master.filter.dateModel)
          return this.master.filter.dateModel;
      },
      display_contract_name(){
        if(this.master.contract_name){
          return this.master.contract_name;
        }
      },
    },

    methods: {
      ...mapActions({
            getItems: 'DashboardV3Controller/getItems',
        }), 
      async getDashboardV3Data() {
        if(this.master.contract_id && this.master.contract_term_id){
          
          if(this.master.filter.dates.length == 0){
            var today = moment();
            var month = today.month()+1;
            var enddate = moment().clone();
            var startdate = moment().clone();
            if(month<=6){
              startdate = moment().clone().startOf("year");
            }
            else{
              startdate = moment().clone().startOf("year").add(6,"months").startOf("month");
            }
            enddate = startdate.clone().add(5,"months").endOf("month");

            var currentPeriod = startdate.format("MMM YYYY")+" - "+enddate.format("MMM YYYY");
            var startdate1= startdate.clone().add(-3,"years");
            var enddate1 = startdate1.clone();
            var dates = [];
            for(var i=0;i<8;i++){
              startdate1 = startdate1.clone().add(6,"months").startOf("month");
              enddate1 = startdate1.clone().add(5,"months").endOf("month");
              dates.push(startdate1.format("MMM YYYY")+" - "+enddate1.format("MMM YYYY"));
            }
            this.master.filter.dates = dates;
            this.master.filter.start_date = startdate.toDate();
            this.master.filter.end_date = enddate.toDate();
            this.master.filter.dateModel = currentPeriod;
            
            this.modals.filter.data.dates = this.master.filter.dates;
            this.modals.filter.data.start_date = this.master.filter.start_date;
            this.modals.filter.data.end_date = this.master.filter.end_date;
            this.modals.filter.data.dateModel = this.master.filter.dateModel;
            }
            var params={};

            params.client_contract_id = this.master.contract_id;
            params.property_id = this.master.filter.property.id;
            var dateModel = this.master.filter.dateModel;
            var dateModelArr = dateModel.replace(" ","").split("-");
            var start_date = moment(dateModelArr[0], "MMMYYYY").startOf("month");
            var end_date = moment(dateModelArr[1], "MMMYYYY").endOf("month");
            params.start_date = start_date.format('YYYY-MM-DD');
            params.end_date = end_date.format('YYYY-MM-DD');

            this.loadingData = false;

            var height = window.innerHeight * 0.62;
            if(height<125){
              height =125;
            }

            //1.job
            params.data_key = 'fm_6msafety_job';

            await this.getItems(params)
                .then(response => {
                    var data = {};
                    data.height = height;

                    if(response.job){
                      data.original = response.job;
                      const unique_status = _.map(_.uniqBy(response.job, (obj) => obj.job_status),'job_status');
                      const unique_category = _.map(_.uniqBy(response.job, (obj) => obj.group_name),'group_name');
                      data.status = unique_status;
                      data.category = unique_category;

                      const category_status= [];
                      _.map(response.job,function (o){ 
                        if(category_status[o.group_name]){
                          category_status[o.group_name].push(o.job_status);
                        }else{
                          category_status[o.group_name]=[];
                          category_status[o.group_name].push(o.job_status);
                        }
                      });
                      data.category_status = category_status;
                      
                      var all_status_count = [];
                      unique_status.forEach(status => {
                        var status_count = [];
                        status_count.push(status);
                        unique_category.forEach(category => {
                          var obj_to_locate = { 'group_name': category, 'job_status': status };
                          const result = _.find(response.job, obj_to_locate);
                          if(result)
                            status_count.push(result.count);
                          else 
                            status_count.push(0);
                        });
                        all_status_count.push(status_count);
                      });
                      data.all_status_count=all_status_count;
                    }
                
                    let that = this;
                    setTimeout(function (data){
                      that.loadVerticalGroupBarChart('#jobStatusBarChart1',data,'group_name','job_status');
                    }, 100,data);
                })
                .catch(err => {
                    console.log(err);
                    let that = this;
                    setTimeout(function (id,height){
                      that.showNoDataChart(id,height);
                    }, 100,'#jobStatusBarChart1',height);
                });
        }
      },  
      async loadRootProperty(){
            await global.axios(`api/contracts/${this.master.contract_id}/tree-properties/0`, {
                method: "GET",
                data: {},
                headers: {
                    Accept: "application/json",
                }
            })
            .then(result => {
                this.master.root_property_id = result.data.data[0].id;
                this.master.filter.property = { id: result.data.data[0].id, name: result.data.data[0].name };
                this.modals.filter.data.property = { id: result.data.data[0].id, name: result.data.data[0].name };
                this.loadRootServiceCategory();
                
            })
            .catch(error => {
                console.log(error);
                this.init = false;
            });
      },
      loadRootServiceCategory() {
          global.axios(`api/contracts/${this.master.contract_id}/tree-service-categories/0`, {
                  method: "GET",
                  headers: {
                      Accept: "application/json",
                  }
              })
              .then(result => {
                  this.master.root_service_category_id = result.data.data[0].id;
                  this.master.filter.service_category = { id: result.data.data[0].id, name: result.data.data[0].name };
                  this.modals.filter.data.service_category = { id: result.data.data[0].id, name: result.data.data[0].name };
                  this.getDataService(result.data.data[0].id,'all',true);
                  this.getDashboardV3Data();
                  this.init = false;
              })
              .catch(error => {
                  console.log(error);
                  this.init = false;
              });
      },
      applyFilter(){
        this.loadingData = true;
        this.modals.filter.open = false;
        this.master.filter.start_date = this.modals.filter.data.start_date;
        this.master.filter.end_date = this.modals.filter.data.end_date;
        this.master.filter.property = this.modals.filter.data.property;
        this.master.filter.dateModel = this.modals.filter.data.dateModel;
        this.getDashboardV3Data();
      },
      openFilterPopup(){
        this.modals.filter.data.start_date = this.master.filter.start_date;
        this.modals.filter.data.end_date = this.master.filter.end_date;
        this.modals.filter.data.property = this.master.filter.property;
        this.modals.filter.open = true;
      },
      loadLoadingCharts(height){
        let that = this;
        setTimeout(function (height){
          var message = "";
          that.showLoadingMessage('#jobStatusBarChart1',height,message);
        }, 100,height);
      },
      showV3Card(id){
        const div = document.querySelector(id);
        let divV3 = div.closest('.v3-card');
        if(divV3)divV3.style.display = 'block';
      },
      showNoDataChart(id,height){
      },
      showMessage(id,height,message){
        const div = document.querySelector(id);
        div.innerHTML = "<div class='div-message' style='min-height:"+height+"px;line-height:"+height+"px;'>"+message+"</div>";
      },
      showLoadingMessage(id,height,message){
        const div = document.querySelector(id);
        div.innerHTML = "<div class='div-message run-loading' style='min-height:"+height+"px;line-height:"+height+"px;'>"+message+"</div>";

      },
      loadVerticalGroupBarChart(div_id,data, groupKey, subGroupKey){
        var yLabelName = '';
        if(subGroupKey=='job_status'){
          yLabelName = '# of PM Jobs';
        }
        else if(subGroupKey=='order_status'){
          yLabelName = '# of Work Orders';
          
        }
        else if(subGroupKey=='case_status'){
          yLabelName = '# of Cases';
        }
        
        if(data.original && data.original.length == 0){
          this.showNoDataChart(div_id,data.height);
          return;
        }
        
        var summary = _(data.original)
        .groupBy(x => x[groupKey])
        .map((value, key) => ({category: key, count: _.sumBy(value, function(o) { return o.count; })
        }))
        .value();

        var all_counts = 0;
        _.map(summary,function(o){all_counts+=o.count;});

        if(all_counts==0) return;
        
        this.showV3Card(div_id);

        var result = _(data.original)
            .groupBy(x => x[groupKey])
            .map((value, key) => ({category: key, data: value}))
            .value();

        var pivot_arr = [];
        result.forEach(x => { 
          var n = {};
          n.category = x.category;
          n.category_status = data.category_status[n.category];
          data.status.forEach(y=> {
            var obj_to_locate = { [subGroupKey]: y };
            const f = _.find(x.data, obj_to_locate);
            if(f){
              n[y] = f.count;
            }
            else{
              n[y] = 0;
            }
          });
          pivot_arr.push(n);

        });

        const div = document.querySelector(div_id);
        div.innerHTML = "";
        var div_width = window.innerWidth * 0.65;
          // set the dimensions and margins of the graph
          const margin = {top: 10, right: 20, bottom: 60, left: 20},
              width = div_width - margin.left - margin.right,
              height = data.height - margin.top - margin.bottom;

          // append the svg object to the body of the page
          const svg = d3.select(div_id)
            .append("svg")
              .attr("width", width + margin.left + margin.right)
              .attr("height", height + margin.top + margin.bottom)
              .append("g")
              .attr("transform", `translate(${margin.left},${margin.top})`);

            const subgroups = data.status;
            const groups = data.category;

            // Add X axis
            const x = d3.scaleBand()
                .domain(groups)
                .range([0, width])
                .padding([data.category.length == 1 ? 0.3 : 0.2]);

            const axisFontSize = "0.9em";
            const totalFontSize = "0.9em";
            const legendFontSize = "0.8em";

            svg.append("g")
              .attr("transform", `translate(0, ${height})`)
              .call(d3.axisBottom(x).tickSizeOuter(0))
                .attr('font-size',axisFontSize)
                .attr('font-family','sans-serif')
              .selectAll(".tick text")
              .call(this.wrap, x.bandwidth());

            var yMax = d3.max(pivot_arr, d => {
              var val = 0
              for(var k of subgroups){
                val += d[k]
              }
              return val;
            });
            yMax = yMax + (yMax * 0.1);

            // Add Y axis
            const y = d3.scaleLinear()
              .domain([0, yMax])
              .range([ height, 0 ]);

            const yAxisGrid = d3.axisLeft(y).tickSize(-width).ticks(10);
            svg.append('g')
            .attr("transform", "translate(3,0)")
            .attr('class', 'dgrid')
            .call(yAxisGrid)
            .attr('font-size',axisFontSize)
            .attr('font-family','sans-serif');

            var color_range = [];
            for(var k of subgroups){
              color_range.push(this.pm1_chart_colors[k]);
            }

            const color = d3.scaleOrdinal()
              .domain(subgroups)
              .range(color_range);

            const stackedData = d3.stack()
              .keys(subgroups)
              (pivot_arr);

            var xSubgroup = d3.scaleBand()
              .domain(subgroups)
              .range([0, x.bandwidth()])
              .padding([0.01]);
                        
            const tooltip = d3.select(div_id)
              .append("div")
              .style("opacity", 0)
              .attr("class", "tooltip")
              .style("background-color", "white")
              .style("border", "solid")
              .style("border-width", "1px")
              .style("border-radius", "5px")
              .style("padding", "10px");

            var that = this;
            const mouseover = function(event, d) {
                var table = "<table><tr>";
              const rows = _.map(d, function(value, key) {
                    return ""
                      + "<td style='padding:2px;'>"
                      + "<span style='background-color:"+that.pm1_chart_colors[value]+";'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;"
                      + value
                      + "</td>"
                      + "";
              });
              table += rows.join('');
              table += "</tr></table>";
              tooltip
                  .html(table)
                  .style("opacity", 1);

            };
            const mousemove = function(event, d) {
              const [x, y] = d3.pointer(event);
              var barPos = parseFloat(d3.select(this.parentNode).attr('transform').split("(")[1]);
                
              var xPosition = barPos + x;
              var yPosition = parseFloat(d3.select(this).attr("y")) / 2 + height / 2;
              tooltip
                    .style("left",xPosition+"px")
                    .style("top",yPosition+"px");
            };
            const mouseleave = function(event, d) {
              tooltip
                .style("opacity", 0)
            };

            // Show the bars
          svg.append("g")
            .selectAll("g")
            // Enter in data = loop group per group
            .data(pivot_arr )
            .enter()
            .append("g")
              .attr("transform", function(d) { return "translate(" + x(d.category) + ",0)"; })
            .selectAll("rect")
            .data(function(d) { return subgroups.map(function(key) { return {key: key, value: d[key]}; }); })
            .enter().append("rect")
              .attr("x", function(d) { return xSubgroup(d.key); })
              .attr("y", function(d) { return y(d.value); })
              .attr("width", xSubgroup.bandwidth())
              .attr("height", function(d) { return height - y(d.value); })
              .attr("fill", function(d) { return color(d.key); });
              
          // Total
            svg.append("g")
              .selectAll("g")
              // Enter in data = loop group per group
              .data(pivot_arr )
              .enter()
              .append("g")
                .attr("transform", function(d) { return "translate(" + x(d.category) + ",0)"; })
              .selectAll("rect")
              .data(function(d) { return subgroups.map(function(key) { return {key: key, value: d[key]}; }); })
              .enter().append("text")
                .attr("x", function(d) { return xSubgroup(d.key)+(xSubgroup.bandwidth() / 2); })
                .attr("y", function(d) { return y(d.value)-2; })
                .attr("fill", "#000000")
                .attr('text-anchor', 'middle')
            .attr("transform", d => d.transform)
            .attr('font-size',totalFontSize)
            .attr('font-family','sans-serif')
            .text(function(d) { 
              return d.value; 
            })
            .style("opacity", 0)
            .transition()
            .duration(1000)
            .style("opacity", 1)
            ;   
                

            // Animation
            svg.selectAll("rect")
              .transition()
              .duration(2000)
              .style("opacity", 1)
              .delay((d,i) => {return i*100});

            var lengnd_margin_left = window.innerWidth / 20;
            if(window.innerWidth > 1024){
              lengnd_margin_left = window.innerWidth / 8;
            }
            
            var legend_spacing = window.innerWidth / 15;
            var legend_spacing_0 = window.innerWidth / 24;
            var legend_spacing_1 = window.innerWidth / 30;
            
            if(window.innerWidth <= 1024){
              legend_spacing = window.innerWidth / 12;
              legend_spacing_0 = window.innerWidth / 12;
              legend_spacing_1 = window.innerWidth / 16;
            }

            //legends
            var keys = ["TOTAL NUMBER OF BLOCKS","PLANNED","VERIFIED","EXPIRED/MISSED"];
            // Add one dot in the legend for each name.
            var size = 10;
            var legend_height = height+((margin.bottom/2)*1.5);
            svg.selectAll("mydots")
              .data(keys)
              .enter()
              .append("rect")
                .attr("x", function(d,i){ return lengnd_margin_left + i*(size+legend_spacing) + (i==1 ? legend_spacing_0 : (i>1 ? legend_spacing_1 : 0))})
                .attr("y", legend_height) // 100 is where the first dot appears. 25 is the distance between dots
                .attr("width", size)
                .attr("height", size)
                .style("fill", function(d){ return color(d)});

            // Add one dot in the legend for each name.
            svg.selectAll("mylabels")
              .data(keys)
              .enter()
              .append("text")
                .attr("x", function(d,i){ return lengnd_margin_left + i*(size+legend_spacing) + (size*1.2) + (i==1 ? legend_spacing_0 : (i>1 ? legend_spacing_1 : 0))}
            )
                .attr("y", legend_height + size*0.6
            ) // 100 is where the first dot appears. 25 is the distance between dots
                .style("fill", function(d){ return color(d)})
                .text(function(d){ return d})
                .attr("text-anchor", "left")
                .style("alignment-baseline", "middle")
              .attr('font-size',legendFontSize)
              .attr('font-family','sans-serif');
    
      },      
     wrap(text, width) {
      var x=0;
      text.each(function() {
        var text = d3.select(this),
            words = text.text().trim().split(/\s+/).reverse(),
            word,
            line = [],
            lineNumber = -1,
            lineHeight = 1.1, // ems
            y = text.attr("y"),
            dy = parseFloat(text.attr("dy")),
            tspan = text.text(null).append("tspan").attr("x", x).attr("y", y).attr("dy", dy + "em");
        while (word = words.pop()) {
          lineNumber++;
          line.push(word);
          tspan.text(line.join(" "));
          if (tspan.node().getComputedTextLength() > width) {
            line.pop();
            tspan.text(line.join(" "));
            line = [word];
            tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", lineNumber * lineHeight + dy + "em").text(word);
          }
        }
      });
    },
     wrapY(text, width) {
      var x=-6;
      var lineCount = 0;
      text.each(function() {
        var text = d3.select(this),
            words = text.text().trim().split(/\s+/).reverse(),
            word,
            line = [],
            lineNumber = 0,
            lineHeight = 1.1, // ems
            y = text.attr("y"),
            dy = parseFloat(text.attr("dy")),
            tspan = text.text(null).append("tspan").attr("x", x).attr("y", y).attr("dy", dy + "em");
            lineCount = 1;
        while (word = words.pop()) {
          if(lineCount < 2){
            line.push(word);
            tspan.text(line.join(" "));
            if (tspan.node().getComputedTextLength() > width) {
              line.pop();
              tspan.text(line.join(" "));
              line = [word];
              tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
              lineCount += 1;
            }
          }
        }
      });
    },
      loadOptionsService({ action, parentNode, callback,instanceId  }){
        if(parentNode.isBatch){
          if (action === LOAD_CHILDREN_OPTIONS ) {
              simulateAsyncOperation(async () => {
                  parentNode.children = await this.getDataService(parentNode.data.id,'all',false);
                  callback()
              })
          }
        }else{
            parentNode.children = undefined;
            callback()
        }
      },
      normalizerService(node) {
          if(node.data && !node.data.isBatch){
              return {
                  children : undefined,
                  label: node.name
              }
          }
          return {
              label: node.name
          }
      },
      async getDataService(parent_id,node_type,set = false){
          let data = [];
          await global.axios(`api/master/tree-service-categories/${parent_id}`, {
              method: "GET",
              headers: { Accept: "application/json", },
              params: {
                  node_type: node_type
              },
          })
              .then(response => {
                  data = response.data.data;
              }).catch(error => {
                  console.log(error);
              });
          if(set){
              this.dataService = data;
          }else{
              return data
          }
      },
    },
    watch: {
      ClientContractID: function(val, old){
          if(!val){
              this.$router.go();
          }
          else if((val && old && old.id && val.id !== old.id)||(!old && val)||(!old.id && val.id)){
            this.loadingData = true;
            this.master.contract_id = this.ClientContractID.id;
            this.master.contract_term_id = this.ClientContractID.contract_terms[0].id;
            this.loadRootProperty();
          }
          else {
            this.loadingData = false;
          }
      }
    }
  }
</script>